import { render } from "./search-drawer.vue?vue&type=template&id=1580354e"
import script from "./search-drawer.vue?vue&type=script&lang=js"
export * from "./search-drawer.vue?vue&type=script&lang=js"

import "./search-drawer.vue?vue&type=style&index=0&id=1580354e&lang=scss"

import exportComponent from "/Users/connoringold/Documents/projects/bao/toteme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__